<template>
  <main class="task-page">
    <div style="font-size: 16px; font-weight: bold; margin:5px">
      {{ $t('taskPage.task') }}
    </div>
    <div v-if="task"
         class="container"
    >
      <ItemGrid :normal-columns="4"
                :normal-rows="-1"
                :xs-columns="1"
                :xs-rows="-1"
      >
        <MainInput :text="task.Nr"
                   type="text"
                   name="TaskNr"
                   :placeholder="$t('taskPage.taskNumber')"
                   :is-readonly="true"
        />
        <MainInput :text="$t('taskPage.status' + task.Status)"
                   type="text"
                   name="TaskStatus"
                   :placeholder="$t('taskPage.status')"
                   :is-readonly="true"
        />
        <MainInput :text="getBackendPriority"
                   type="text"
                   name="TaskPriority"
                   :placeholder="$t('taskPage.priority')"
                   :is-readonly="true"
        />
        <MainInput :text="task.CustomT2"
                   type="text"
                   name="TaskCustomT2"
                   :placeholder="$t('taskPage.customT2')"
                   :is-readonly="true"
        />
        <MainInput :text="task.StartDate.substring(0, 10) +
                     (new Date(task.StopDate).setDate(new Date(task.StopDate).getDate() - 1) >
                       new Date(task.StartDate)
                       ? ' - ' + task.StopDate.substring(0, 10)
                       : '')"
                   type="text"
                   name="TaskDate"
                   :placeholder="$t('taskPage.taskDate')"
                   :is-readonly="true"
        />

        <MainInput :text="task.Customer.Name"
                   type="text"
                   name="Customer"
                   style="height:50px; vertical-align: center;"
                   :placeholder="$t('taskPage.customer')"
                   :is-readonly="true"
        />
        <MainInput :text="task.Object1?.Name || ''"
                   type="text"
                   name="Object1"
                   :placeholder="$t('taskPage.object1')"
                   :is-readonly="true"
        />
        <MainInput :text="task.UserProperties?.[10063]?.Value ?? ''"
           type="text"
           name="TaskDescription"
           :placeholder="$t('taskPage.taskdescription')"
           :is-readonly="true"
        />
        <MainInput :text="task.TaskText"
                   type="textarea"
                   name="TaskText"
                   style="height:100px"
                   :placeholder="$t('taskPage.taskText')"
                   :is-readonly="true"
        />
        <MainInput :text="task.ActionText"
                   type="textarea"
                   name="ActionText"
                   style="height:100px"
                   :placeholder="$t('taskPage.actionText')"
                   :is-readonly="true"
        />
        <MainInput :text="(task.Owner && task.Owner.Name) ? task.Owner.Name : $t('taskPage.none')"
                   type="text"
                   name="TaskOwner"
                   :placeholder="$t('taskPage.owner')"
                   :is-readonly="true"
        />
        <MainInput :text="task.Performers.length === 0 ?
                     $t('taskPage.none')
                     :
                     task.Performers.map(performer => performer.Name).join(', ')"
                   type="textarea"
                   style="height:60px"
                   name="TaskPerformers"
                   :placeholder="$t('taskPage.performers')"
                   :is-readonly="true"
        />
      </ItemGrid>
      <div class="content-section">
        <table class="styled-table">
          <thead>
            <tr>
              <th @click="toggleDocumentTable">
                {{ isDocumentTableVisible ? '▼' : '▲' }} {{ $t('taskPage.documents') }}
              </th>
              <th />
              <th />
            </tr>
          </thead>
          <thead>
            <tr>
              <th
                @click="setSort({ key: 'Name', reverse: false })"
              >
                {{ $t('taskPage.documentName') }}
              </th>
              <th>
                {{ $t('taskPage.documentFileExtension') }}
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr v-if="!isReadOnly" v-show="isDocumentTableVisible" class="attachment-row">
              <td colspan="3">
                <FileDropZone :title="isUploadingDocument ? $t('documentPage.uploading') : $t('taskPage.attachDocument')"
                              :hint="$t('documentPage.dropFilesHere')"
                              :drop-label="$t('documentPage.dropFilesNow')"
                              :choose-label="$t('documentPage.chooseFiles')"
                              :accepted-types="acceptedFileTypesLabel"
                              :accept="acceptedFileExtensions"
                              :disabled="isUploadingDocument"
                              @files-selected="attachDocuments"
                />
              </td>
            </tr>
            <tr v-for="document in documents"
                v-show="isDocumentTableVisible"
                :key="document.Id"
                class="taskRow"
            >
              <td class="tdTask">
                {{ document.Name }}
              </td>
              <td class="tdTask">
                {{ document.Extension }}
              </td>
              <td style="cursor: pointer; text-align: right; padding-right:10px;"
                  @click="downloadFile(document)"
              >
                <button v-if="canRemoveDocument(store, document)"
                        class="remove-button"
                        :title="$t('documentPage.remove')"
                        :aria-label="$t('documentPage.remove')"
                        @click.stop="removeDocument(document)"
                >
                  <span class="material-icons">delete</span>
                </button>
                <span class="material-icons">download</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="isUkEnvironment" class="content-section">
        <table class="styled-table">
          <thead>
            <tr>
              <th @click="toggleReportTable">
                {{ isReportTableVisible ? '▼' : '▲' }} {{ $t('taskPage.reports') }}
              </th>
              <th />
              <th />
            </tr>
          </thead>
          <thead>
            <tr>
              <th>{{ $t('taskPage.documentName') }}</th>
              <th>{{ $t('taskPage.documentFileExtension') }}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr v-if="!isReadOnly" v-show="isReportTableVisible" class="attachment-row">
              <td colspan="3">
                <FileDropZone :title="isUploadingReport ? $t('documentPage.uploading') : $t('taskPage.attachReport')"
                              :hint="$t('documentPage.dropFilesHere')"
                              :drop-label="$t('documentPage.dropFilesNow')"
                              :choose-label="$t('documentPage.chooseFiles')"
                              :accepted-types="acceptedFileTypesLabel"
                              :accept="acceptedFileExtensions"
                              :disabled="isUploadingReport"
                              @files-selected="attachReports"
                />
              </td>
            </tr>
            <tr v-for="report in reports"
                v-show="isReportTableVisible"
                :key="report.Id"
                class="taskRow"
            >
              <td class="tdTask">{{ report.Name }}</td>
              <td class="tdTask">{{ report.Extension }}</td>
              <td style="cursor: pointer; text-align: right; padding-right:10px;"
                  @click="downloadFile(report)"
              >
                <button v-if="canRemoveDocument(store, report)"
                        class="remove-button"
                        :title="$t('documentPage.remove')"
                        :aria-label="$t('documentPage.remove')"
                        @click.stop="removeDocument(report)"
                >
                  <span class="material-icons">delete</span>
                </button>
                <span class="material-icons">download</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content-section data-section">
        <TaskList :tasks="filteredTaskTimes"
                  show-header="true"
                  :header-text="$t('taskPage.times')"
                  :table-columns="['StartDate', 'Time', 'UserSign', 'Spec']"
                  redirect="false"
                  object-type="times"
        />
      </div>

      <div class="content-section data-section">
        <TaskList :tasks="filteredTaskMaterials"
                  show-header="true"
                  :header-text="$t('taskPage.materials')"
                  :table-columns="['ArtName', 'Amount']"
                  redirect="false"
                  object-type="materials"
        />
      </div>
      <div class="content-section">
        <table class="styled-table">
          <thead>
            <tr>
              <th @click="toggleMessageTable">
                {{ isMessageTableVisible ? '▼' : '▲' }} {{ $t('taskPage.messages') }}
              </th>
              <th />
              <th />
            </tr>
          </thead>
          <thead>
            <tr>
              <th style="width:10%"
                  @click="setSort({ key: 'Sender', reverse: false })"
              >
                {{ $t('taskPage.user') }}
              </th>
              <th @click="setSort({ key: 'Message', reverse: false })">
                {{ $t('taskPage.message') }}
              </th>
              <th style="text-align: right;"
                  @click="setSort({ key: 'Created', reverse: false })"
              >
                {{ $t('taskPage.timestamp') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="message in task.Messages"
                v-show="isMessageTableVisible"
                :key="message.Id"
                class="taskRow"
            >
              <td class="tdTask"
                  style="width:10%"
              >
                {{ message.Sender }}
              </td>
              <td class="tdTask">
                {{ message.Message }}
              </td>
              <td class="tdTask"
                  style="text-align: right;"
              >
                {{ formatTimestamp(message.Created) }}
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!isReadOnly">
          <form
            @submit.prevent="sendMessage"
          >
            <div class="textarea-container">
              <textarea :placeholder="$t(`taskPage.newMessage`)"
                        :value="taskMessage"
                        @input="setTaskMessage"
              />
              <button style="margin-right:12px"
                      type="submit"
              >
                {{ $t('taskPage.sendMessage') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>
<script setup>
import TaskList from '@/components/task/TaskList.vue'
import ItemGrid from '@/components/grid/ItemGrid.vue'
import MainInput from '@/components/inputs/MainInput.vue'
import FileDropZone from '@/components/inputs/FileDropZone.vue'
import { defineProps, onMounted, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { PostDocument } from '@/api/document.js'
import { useToast } from 'vue-toastification'
import i18n from '@/locales/i18n'
import { isReportEnvironment } from '@/utils/environment.js'
import { canRemoveDocument, confirmAndRemoveDocument } from '@/utils/removeDocument.js'

const toast = useToast()
const store = useStore()

const task = computed(() => store.state.task.currentTask)
const taskMaterials = computed(() => store.state.task.currentTaskMaterials)
const taskTimes = computed(() => store.state.task.currentTaskTimes)
const reportCategory = 'REPORT'
const isUkEnvironment = isReportEnvironment()
const isReadOnly = computed(() => store.getters['account/isReadOnly'])
const documents = computed(() => (task.value?.Documents ?? []).filter(document => document.Category !== reportCategory))
const reports = computed(() => (task.value?.Documents ?? []).filter(document => document.Category === reportCategory))

const updatedTaskMaterials = computed(() => {
  return taskMaterials.value.map(material => {
    if (material.InvoiceAmount === 0) {
      return { ...material, InvoiceAmount: material.Amount }
    }
    return material
  })
})

const updatedTaskTimes = computed(() => {
  return taskTimes.value.map(time => {
    if (time.InvoiceTime === 0) {
      return { ...time, InvoiceTime: time.Time }
    }
    return time
  })
})

const filteredTaskMaterials = computed(() => {
  return updatedTaskMaterials.value.filter(material =>
    Object.values(material.UserProperties ?? {}).some(prop => prop.Name === 'D365 Invoiced' && prop.Value === '1')
  )
})

const filteredTaskTimes = computed(() => {
  return updatedTaskTimes.value.filter(time =>
    Object.values(time.UserProperties ?? {}).some(prop => prop.Name === 'D365 Invoiced' && prop.Value === '1')
  )
})

const props = defineProps({
  id: {
    type: Number,
    required: true
  }
})

const setTaskMessage = (x) => store.commit('task/setTaskMessage', x.target.value)
const taskMessage = computed(() => store.state.task.taskMessage)

const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp)
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    locale: 'sv-SE'
  }

  return new Intl.DateTimeFormat('sv-SE', options).format(date)
}
const allowedExtensions = computed(() => store.state.document.allowedExtensions)
const acceptedFileExtensions = computed(() => allowedExtensions.value.map(extension => `.${extension}`).join(','))
const acceptedFileTypesLabel = computed(() => allowedExtensions.value.length > 0
  ? i18n.global.t('documentPage.allowedFileTypes', { types: allowedExtensions.value.join(', ') })
  : '')
const isUploadingDocument = ref(false)
const isUploadingReport = ref(false)

onMounted(async () => {
  store.dispatch('document/getAllowedFileExtensions')
  await store.dispatch('task/getTaskById', props.id)
  await store.dispatch('message/getBaseData')
})

async function attachDocuments (files) {
  isUploadingDocument.value = true
  try {
    await uploadFiles(files)
  } finally {
    isUploadingDocument.value = false
  }
}

async function attachReports (files) {
  isUploadingReport.value = true
  try {
    await uploadFiles(files, reportCategory)
  } finally {
    isUploadingReport.value = false
  }
}

async function uploadFiles (files, category = null) {
  const formdata = new FormData()

  const normalizedAllowedExtensions = allowedExtensions.value.map(extension => extension.toLowerCase())
  let allFilesAllowed = true
  for (const file of files) {
    const fileParts = file.name.split('.')
    const fileExtension = fileParts[fileParts.length - 1].toLowerCase()
    if (normalizedAllowedExtensions.indexOf(fileExtension) === -1) {
      allFilesAllowed = false
      break
    }
  }

  if (!allFilesAllowed) {
    toast.info(i18n.global.t('documentPage.fileTypesNotAllowed') + allowedExtensions.value.join(', '))
    return
  }

  for (const file of files) {
    formdata.append('file', file)
  }
  try {
    const postResponse = await PostDocument('task', task.value.Id, formdata, category)
    // console.log(postResponse)
    if (postResponse.status === 200) {
      store.dispatch('task/getTaskById', props.id)
      toast.success(i18n.global.t('documentPage.uploadSuccess'))
    } else {
      toast.warning(i18n.global.t('documentPage.uploadFail'))
    }
  } catch (e) {
    toast.warning(e.message)
  }
}

const isMessageTableVisible = ref(true)
const toggleMessageTable = () => {
  isMessageTableVisible.value = !isMessageTableVisible.value
}

const isDocumentTableVisible = ref(true)
const toggleDocumentTable = () => {
  isDocumentTableVisible.value = !isDocumentTableVisible.value
}

const isReportTableVisible = ref(true)
const toggleReportTable = () => {
  isReportTableVisible.value = !isReportTableVisible.value
}

const sendMessage = () => store.dispatch('task/postMessage')

async function removeDocument (documentInfo) {
  if (await confirmAndRemoveDocument(documentInfo, toast)) {
    store.dispatch('task/getTaskById', props.id)
  }
}

async function downloadFile (documentInfo) {
  try {
    const byteCharacters = window.atob(documentInfo.Base64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512)
      const byteNumbers = new Array(slice.length)

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: 'application/' + documentInfo.Extension })

    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = documentInfo.Name + '.' + documentInfo.Extension
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
  } catch (e) {
    console.error('Error during file download:', e)
    toast.error(i18n.global.t('documentPage.DownloadFailed') + '\r\n\r\n' + e.message)
  }
}
const setSort = (option) => store.dispatch('task/setSort', option)

const eligiblePriorities = computed(() => ({
  Low: i18n.global.t('taskPage.priorityLow'),
  Normal: i18n.global.t('taskPage.priorityNormal'),
  High: i18n.global.t('taskPage.priorityHigh')
}))

// The Mobigo Priority should exist as a key in below dict
const priorityMapping = {
  UK: { Low: 'Low', Normal: 'Normal', High: 'High' },
  SE: { Låg: 'Low', Normal: 'Normal', Akut: 'High', Hög: 'High' },
  DK: { Lav: 'Low', Normal: 'Normal', Akut: 'High' },
  NO: { Låg: 'Low', Normal: 'Normal', High: 'High' },
  NL: { Low: 'Low', Normal: 'Normal', High: 'High' }
}

const currentEnv = window.apiConfig.ENV || 'UK'
const getBackendPriority = computed(() => {
  const environmentMapping = priorityMapping[currentEnv] || priorityMapping.UK
  const taskPriority = task.value?.Priority || 'Normal' // Fetching the task priority

  const backendPriority = environmentMapping[taskPriority] || 'Normal' // Default to 'Normal'

  // Get the translated value from eligiblePriorities
  return eligiblePriorities.value[backendPriority] || backendPriority // Fall back to backendPriority if translation isn't available
})

</script>

<style lang="scss" scoped>
.task-page {
  height: 100%;
  overflow: scroll;
  background: var(--mainBackground);
  .container{
    padding: 1rem;
  }
}

.styled-table {
  table-layout: fixed;
  border-collapse: collapse;
  margin: 0;
  font-size: 0.9em;
  font-family: 'Lexend', sans-serif;
  width: 100%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.content-section {
  margin-top: 24px;
}

.data-section :deep(.styled-table) {
  margin: 0;
}

.styled-table thead tr {
  background-color: var(--mainBlue);
  color: white;
  text-align: left;
  cursor: pointer; /* Add this line to set the cursor to pointer on hover */
}

.styled-table th {
  padding: 12px 15px;
  text-align: left;
}

.styled-table tbody tr {
  border-bottom: 1px solid lightgrey;
  background-color: white;
  color: black;
}

.remove-button {
  margin-right: 12px;
  padding: 0;
  line-height: 0;
  color: #b3261e;
  vertical-align: middle;
}

.attachment-row td {
  padding: 12px;
  background: white;
}

.taskRow{
  border-bottom: 1px solid lightgrey;
  background-color: white;
  color: black;
  height: 20px;

  .header{
    font-weight: bold;
  }
}

.taskRow:nth-of-type(2n) {
  background-color: var(--alternatingListColor);
  color: black;
}

.taskRow:last-of-type {
  border-bottom: 3px solid var(--mainBlue);
}

.tdTask {
  padding: 10px 15px;
  text-align: left;
  transition: padding 0.4s ease;

}
.textarea-container {
  position: relative;
}

.textarea-container textarea {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: none;
}

.textarea-container button {
  position: absolute;
  right: 0;
  bottom: 10px;
  right: 10px;
  padding: 12px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.textarea-container button:hover {
  background-color: #45a049;
}
</style>
